import { Context, Effect, Layer, pipe, Schema } from "effect";
import sodium from "libsodium-wrappers";
import { SealedSecretValueStructFromString } from "../SealingSecretsSchema";
import { SecretUnsealerError } from "./SecretUnsealerErrors";
import { SecretUnsealerPrivateKeyProvider } from "./SecretUnsealerPrivateKeyProvider";
//
// Service Definition
//
const make = Effect.gen(function*() {
    const privateKeyProvider = yield* SecretUnsealerPrivateKeyProvider;
    const unsealSecretValue = (sealedSecretValue)=>Effect.gen(function*() {
            const { keyId, encryptedSecretValue } = yield* Schema.decodeUnknown(SealedSecretValueStructFromString)(sealedSecretValue);
            const unsealingKey = yield* privateKeyProvider.getPrivateKeyById(keyId);
            yield* Effect.promise(()=>sodium.ready);
            const publicKey = sodium.from_base64(unsealingKey.publicKey);
            const privateKey = sodium.from_base64(unsealingKey.privateKey);
            try {
                const decrypted = sodium.crypto_box_seal_open(sodium.from_base64(encryptedSecretValue), publicKey, privateKey);
                return sodium.to_string(decrypted);
            } catch (error) {
                return yield* Effect.fail(new SecretUnsealerError("UnknownError", error));
            }
        });
    return {
        unsealSecretValue
    };
});
export class SecretUnsealerService extends Context.Tag("@open-revenue/utils/SecretUnsealer/SecretUnsealerService")() {
    static make = make;
    static Live = Layer.effect(this, make);
    static defaultEncoded = pipe(make, Layer.effect(this), Layer.provide(SecretUnsealerPrivateKeyProvider.staticDefaultEncoded));
    static layer = (config)=>pipe(make, Layer.effect(this), Layer.provide(SecretUnsealerPrivateKeyProvider.staticLayer(config)));
    static layerEncoded = (config)=>pipe(make, Layer.effect(this), Layer.provide(SecretUnsealerPrivateKeyProvider.staticLayerEncoded(config)));
    static layerConfig = (config)=>pipe(make, Layer.effect(this), Layer.provide(SecretUnsealerPrivateKeyProvider.staticLayerConfig(config)));
    static layerConfigEncoded = (config)=>pipe(make, Layer.effect(this), Layer.provide(SecretUnsealerPrivateKeyProvider.staticLayerConfigEncoded(config)));
}
